module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "prologue"
    }
  }), _c('a', {
    attrs: {
      "id": "page_ix"
    }
  }, [_vm._v("Prologue")])]), _c('a', {
    attrs: {
      "id": "page_ix"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("The sea gives, and the sea takes away. The sea gave me a great deal, but fickle as it is, it tried to steal it back, and nearly me with it.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("I had never been to the ocean before the year I turned thirteen. Until then I had grown up landlocked, where the only nearby water was a municipal swimming pool that burned my eyes red and turned my hair green. My brother and I lived with our mother in a safe, snug triangle: Mom was the base, and my brother and I were the sides that balanced upon her. We laughed a lot then, and I expected to go on that way forever, but the balance shifted suddenly, and everything changed.")])])]), _c('p', {
    staticClass: "imagec"
  }, [_c('a', {
    attrs: {
      "id": "page_ix"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "height": "69",
      "src": "images/f00ix-01.jpg",
      "width": "85"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_xi"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_xi"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6631d670","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/prologue.vue
// module id = 63
// module chunks = 0